export const alphanumeric = {
    mounted(el) {
        el.addEventListener("keydown", function (event) {
            if (!/[0-9a-zA-Z\s]/i.test(event.key)) {
                event.preventDefault();
            }
        });
    },
};
export const numeric = {
    mounted(el) {
        el.addEventListener("keydown", function (event) {
            const isBackspaceKey = event.key === "Backspace";
            if (isBackspaceKey) {
                return true;
            }
            if (!/[0-9]/i.test(event.key)) {
                event.preventDefault();
            }
        });
    },
};
export const decimalNumber = {
    mounted(el) {
        el.addEventListener("keydown", function (event) {
            const isBackspaceKey = event.key === "Backspace";
            const isDotKey = event.key === "."; // Check for dot key

            if (isBackspaceKey) {
                return true;
            }

            // Allow digits and dot (.) for decimal input
            if (
                !/[\d.]/.test(event.key) ||
                (isDotKey && el.value.includes("."))
            ) {
                event.preventDefault();
            }
        });
    },
};
export const alphabet = {
    mounted(el) {
        el.addEventListener("keydown", function (event) {
            if (!/[a-zA-Z]/i.test(event.key)) {
                event.preventDefault();
            }
        });
    },
};

export const twodigitdecimal = {
    mounted(el) {
        el.addEventListener("keydown", (event) => {
            const isBackspaceKey = event.key === "Backspace";
            if (isBackspaceKey) {
                return true;
            }
            const regex = /^\d*\.?\d{0,1}$/;
            const inputValue = event.target.value;
            if (!regex.test(inputValue)) {
                console.log("invalid");
                // event.target.value = inputValue.slice(0,-1)
                event.preventDefault();
            }
        });
    },
};
